import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import PageWrapper from '../../components/PageWrapper';
import AnimatedSection from '../../components/AnimatedSection';
import './Home.css';
import Banner from '../../components/Banner/Banner';
import CoreAdvantages from '../../components/CoreAdvantages/CoreAdvantages';
import DataShowcase from '../../components/DataShowcase/DataShowcase';
import Services from '../../components/Services/Services';
import Process from '../../components/Process/Process';
import Projects from '../../components/Projects/Projects';
import Testimonials from '../../components/Testimonials/Testimonials';
import Partners from '../../components/Partners/Partners';
import QuickConsult from '../../components/QuickConsult/QuickConsult';

const Home = () => {
  // 滚动触发动画 variants
  const containerVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <PageWrapper className="home-page">
      <Banner />

      <AnimatedSection className="intro-section">
        <div className="container">
          <div className="intro-grid">
            <motion.div className="intro-card" variants={itemVariants}>
              <span className="intro-label">我们相信</span>
              <h3>造价治理不止于数字，更是企业价值管理的核心抓手</h3>
            </motion.div>
            <motion.div className="intro-card" variants={itemVariants}>
              <p>
                识道造价以央企标准构建项目全过程管理体系，将造价咨询、
                招标代理、造价审计与数智平台深度融合，形成"一体化、一盘账、一张图"的治理能力。
              </p>
            </motion.div>
            <motion.div className="intro-card" variants={itemVariants}>
              <ul>
                <li>覆盖建筑、市政、交通、能源等 20+ 行业领域</li>
                <li>央国企、政府、上市公司等多类型客户深度合作</li>
                <li>以成果验收为导向的交付机制与质量保障体系</li>
              </ul>
            </motion.div>
          </div>
        </div>
      </AnimatedSection>

      <AnimatedSection>
        <CoreAdvantages />
      </AnimatedSection>

      <AnimatedSection>
        <DataShowcase />
      </AnimatedSection>

      <AnimatedSection>
        <Services />
      </AnimatedSection>

      <AnimatedSection>
        <Process />
      </AnimatedSection>

      <AnimatedSection>
        <Projects />
      </AnimatedSection>

      <AnimatedSection>
        <Testimonials />
      </AnimatedSection>

      <AnimatedSection>
        <Partners />
      </AnimatedSection>

      <AnimatedSection>
        <QuickConsult />
      </AnimatedSection>
    </PageWrapper>
  );
};

export default Home;